import React from 'react';
import { AppContext } from '@context/AppContext';
import { testNamekey } from '@libs/utilsMsg';

interface ISearchInputProps {
	/** Enter = the primary Find/Create button action for the current state. */
	onEnter?: () => void;
	children?: React.ReactNode;
}

interface ISearchInputState {
	is_error: boolean;
}

class SearchInput extends React.Component<ISearchInputProps, ISearchInputState> {
	constructor(props:ISearchInputProps) {
		super(props);
		
		this.state = {
			is_error: false
		};			
	}
	
	static contextType = AppContext;
	declare context: React.ContextType<typeof AppContext>;
	
	private input_el = React.createRef<HTMLInputElement>();
	
	_resetComponent = () => {
		this.setState({ is_error: false });
	}

	// Programmatic focus only on fine-pointer devices: on phones a forced
	// focus pops the soft keyboard over the first paint (Android) — touch
	// users focus by tapping, like on any search page.
	_canForceFocus = () => window.matchMedia('(pointer: fine)').matches;

	componentDidMount() {
		if (this._canForceFocus()) this.input_el.current!.focus();
	}
	componentWillUnmount() {  }
	componentDidUpdate(prevProps:ISearchInputProps, prevState:ISearchInputState) {
		const { context_data, dispatchContext } = this.context!;

		if (this._canForceFocus() && context_data.is_focused === "SearchInput" && document.activeElement !== this.input_el.current!) {
			this.input_el.current!.focus();
		}
	}
	
	
	isFocused = (is_focused:boolean) => {
		const { context_data, dispatchContext } = this.context!;		
		dispatchContext({ type: "SET", is_focused: is_focused ? "SearchInput" : ""});
	}
	
	handleInputChange = (e:React.ChangeEvent<HTMLInputElement>) => { 
		// The input already has an @ sigil. Accept a pasted/typed leading @
		// while retaining every separator inside the complete address.
		const user_name_key = e.currentTarget.value.replace(/\s\s+/g, ' ').trimLeft().replace(/^@/, '');
		const name_key = user_name_key.replace(/^\s+/gm, "").replace(/\s+/g, " ").trim();		
		const is_empty = name_key === "";	
		const is_error = !is_empty && !testNamekey(name_key);
		
		// this.setState({ is_error: is_error });
		
		const { context_data, dispatchContext } = this.context!;
		dispatchContext({ type: "STATE", state: "enabled", namekey: user_name_key, is_error: is_error });	
	}
		
	dotOnClick = () => {
		const { context_data, dispatchContext } = this.context!;
		dispatchContext({ type: "STATE" });
		
	}
	
	handleKeyUp = (e:React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter") this.props.onEnter?.();
	}
	
	render() {
		const { context_data, dispatchContext } = this.context!;		
		const text_class = context_data.namekey_error ? "text-red-500" : (!context_data.find_enabled && context_data.state !== "google" ? "text-gray-500" : "text-[#222]");
		
		const input_class = "m-0 block w-full rounded-[14px] bg-white border border-gray-400 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-[21px] pr-[15px] pl-[35px] py-[15px] placeholder-gray-500";
		const dot_class = "absolute top-[16px] left-[10px] text-[21px] p-0 cursor-pointer h-[36px]";
		
		return (
			<div className="w-full relative">
				<span onClick={this.dotOnClick} className={`${dot_class} ${text_class}`}>@</span>
				<input ref={this.input_el} onKeyUp={(e) => {this.handleKeyUp(e)}} onBlur={is_foc => this.isFocused(false)} onFocus={is_foc => this.isFocused(true)} onChange={this.handleInputChange} type="text" placeholder="type msg name" className={`${input_class} ${text_class}`} name="key" value={context_data.namekey} />
			</div>
		);
	}
	
}

export default SearchInput;
